
<template >
  <div>
    <div v-if="loading">
      <a-skeleton active />
    </div>

    <b-form v-if="!loading" class="1w-100 form" @submit="onSubmit">
      <b-row cols="3" class="mb-3" v-if="this.merchant.document.length <= 14">
        <b-col>
          <b-btn
            class="col-12"
            variant="outline-primary"
            @click="copyData()"
            :disabled="loading"
          >
            Copiar Dados da Aba "Empresa"
            <b-spinner
              small
              variant="primary"
              label="Spinning"
              v-show="loading"
            ></b-spinner>
          </b-btn>
        </b-col>
      </b-row>
      <b-row cols="3">
        <b-col>
          <b-form-group label="Nome " label-for="fullName">
            <b-form-input
              id="fullName"
              v-model="form.fullName"
              required
              placeholder=""
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Data de Nascimento" label-for="birthDate">
            <b-form-input
              id="birthDate"
              v-model="form.birthDate"
              required
              v-mask="'##/##/####'"
              placeholder=""
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Cpf" label-for="document">
            <b-form-input
              id="document"
              v-model="form.document"
              v-mask="'###.###.###-##'"
              required
              placeholder=""
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row cols="3">
        <b-col>
          <b-form-group label="Email" label-for="email">
            <b-form-input
              id="email"
              v-model="form.email"
              type="email"
              required
              placeholder=""
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Telefone:" label-for="phone">
            <b-form-input
              id="phone"
              v-model="form.phoneNumber"
              required
              v-mask="'(##) #####-####'"
              placeholder=""
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Cep:" label-for="zipCode">
            <b-form-input
              id="zipCode"
              v-model="form.address.zipCode"
              required
              @change="handleZipCode"
              v-mask="'#####-###'"
              placeholder=""
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <h5>Endereço</h5>
      <hr />
      <b-row cols="3">
        <b-col>
          <b-form-group label="Logradouro" label-for="address">
            <b-form-input
              v-if="!isLoadingZipcodeBureau"
              id="address"
              v-model="form.address.street"
              required
              placeholder=""
            ></b-form-input>
            <b-spinner v-else variant="primary" label="Spinning"></b-spinner>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Número" label-for="addressNumber">
            <b-form-input
              v-if="!isLoadingZipcodeBureau"
              id="addressNumber"
              v-model="form.address.number"
              required
              placeholder="Número"
            ></b-form-input>
            <b-spinner v-else variant="primary" label="Spinning"></b-spinner>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Complemento" label-for="addressComplement">
            <b-form-input
              v-if="!isLoadingZipcodeBureau"
              id="addressComplement"
              v-model="form.address.complement"
              placeholder="Complemento"
            ></b-form-input>
            <b-spinner v-else variant="primary" label="Spinning"></b-spinner>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Bairro" label-for="addressDistrict">
            <b-form-input
              v-if="!isLoadingZipcodeBureau"
              id="addressDistrict"
              v-model="form.address.district"
              required
              placeholder="Bairro"
            ></b-form-input>
            <b-spinner v-else variant="primary" label="Spinning"></b-spinner>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group label="Cidade" label-for="addressCity">
            <b-form-input
              v-if="!isLoadingZipcodeBureau"
              id="addressCity"
              v-model="form.address.city"
              required
              placeholder="Cidade"
            ></b-form-input>
            <b-spinner v-else variant="primary" label="Spinning"></b-spinner>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group label="UF" label-for="addressUF">
            <b-form-input
              v-if="!isLoadingZipcodeBureau"
              id="addressUF"
              v-model="form.address.UF"
              required
              placeholder="UF"
            ></b-form-input>
            <b-spinner v-else variant="primary" label="Spinning"></b-spinner>
          </b-form-group>
        </b-col>
      </b-row>

      <h5 style="margin-top:30px">Dados de acesso</h5>
      <hr />
      <b-row cols="1">
        <b-col class="col-xl">
          <h4 v-if="!hasMerchantManager">
            Os dados de acesso serão enviados para o email do representante
          </h4>

          <b-btn
            class="col-md-2"
            v-if="hasMerchantManager"
            @click="forgotPasswordSend"
            variant="outline-primary"
            :disabled="loading"
          >
            Reeviar Senha
            <b-spinner
              small
              variant="primary"
              label="Spinning"
              v-show="loading"
            ></b-spinner>
          </b-btn>

          <b-btn
            class="col-md-2"
            v-if="hasMerchantManager"
            v-b-toggle.collapsePassword
            :disabled="loading"
            style="margin-left:10px"
          >
            Definir Senha
            <b-spinner
              small
              label="Spinning"
              v-show="loading"
            ></b-spinner>
          </b-btn>


        </b-col>
      </b-row>

<div v-if="hasMerchantManager" style="margin-top:30px">
<b-collapse id="collapsePassword">
     <hr />
<b-row>
      
              <b-alert show variant="warning" class="col-md-12">Lembre-se de somente alterar a senha do cliente mediante ao consentimento prévio do mesmo.</b-alert>

            <b-form-group class="col-md-3" label="Nova Senha" label-for="newPassword">
              <b-form-input
                id="newPassword"
                v-model="form.newPassword"
                placeholder="Nova Senha"
              ></b-form-input>

              <b-btn
              class="col-md-12"
          variant="outline-primary"
          style="margin-top: 20px"
            @click="generatePassword"
            :disabled="loading"
          >
            Definir Senha
            <b-spinner
              small
              variant="primary"
              label="Spinning"
              v-show="loading"
            ></b-spinner>
          </b-btn>
              
            </b-form-group>

          
      </b-row>
      </b-collapse>

</div>

      <hr />
      <div class="row">
        <div class="col-xl">
          <b-btn
            type="submit"
            class="col-md-2"
            variant="outline-primary"
            :disabled="loading"
          >
            Salvar
            <b-spinner
              small
              variant="primary"
              label="Spinning"
              v-show="loading"
            ></b-spinner>
          </b-btn>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import {
  get as _get,
  debounce as _debounce,
  cloneDeep as _cloneDeep,
} from "lodash";
import { mask } from "@titou10/v-mask";

import { MerchantManagerResource } from "@/resources/MerchantManager.resource.js";
import { MerchantBurealResource } from "@/resources/MerchantBureal.resource.js";
import { UsuarioResource } from "@/resources/Usuario.resource.js";
import { MaskUtils } from "@/utils/MaskUtils.js";
import moment from "moment";

export default {
  directives: { mask },
  props: {
    merchantRepresentative: {
      type: Object,
      default: () => {},
    },
    merchant: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      merchantManager: {},
      isLoadingZipcodeBureau: false,
      idMerchant: 0,
      loading: false,
      form: {
        fullName: _get(this.merchantRepresentative, "fullName", ""),

        document: _get(this.merchantRepresentative, "document", ""),
        birthDate: moment(
          _get(this.merchantRepresentative, "birthDate", "")
        ).isValid()
          ? moment(_get(this.merchantRepresentative, "birthDate", "")).format(
              "DDMMYYYY"
            )
          : "",
        phoneNumber: _get(this.merchantRepresentative, "phoneNumber", ""),
        fgActive: _get(this.merchantRepresentative, "fgActive", false),
        email: _get(this.merchantRepresentative, "email", ""),
        address: {
          street: _get(this.merchantRepresentative.address, "street", ""),
          district: _get(this.merchantRepresentative.address, "district", ""),
          city: _get(this.merchantRepresentative.address, "city", ""),
          number: _get(this.merchantRepresentative.address, "number", ""),
          complement: _get(
            this.merchantRepresentative.address,
            "complement",
            ""
          ),
          UF: _get(this.merchantRepresentative.address, "uf", ""),
          zipCode: _get(this.merchantRepresentative.address, "zipCode", ""),
        },
      },
    };
  },
  created() {
    if (this.$route.params.id > 0) {
      this.idMerchant = this.$route.params.id;
      this.load();
    }
  },

  computed: {
    hasMerchantManager() {
      try {
        return (
          typeof this.merchantManager.id !== undefined &&
          this.merchantManager.id > 0
        );
      } catch (e) {
        return false;
      }
    },
  },

  methods: {
    load() {
      if (this.idMerchant > 0) {
        this.loading = true;
        MerchantManagerResource.getById({ idMerchant: this.idMerchant })
          .then((result) => {
            try {
              this.merchantManager = {
                address: result.data.payload.userAddress,
                ...result.data.payload.user,
              };

              this.form = {
                fullName: _get(this.merchantManager, "fullName", ""),
                document: _get(this.merchantManager, "document", ""),
                phoneNumber: _get(this.merchantManager, "phoneNumber", ""),
                birthDate: moment(
                  _get(this.merchantManager, "birthDate", "")
                ).isValid()
                  ? moment(_get(this.merchantManager, "birthDate", "")).format(
                      "DDMMYYYY"
                    )
                  : "",
                fgActive: _get(this.merchantManager, "fgActive", false),
                email: _get(this.merchantManager, "email", ""),
                userName: _get(this.merchantManager, "userName", ""),
                address: {
                  street: _get(this.merchantManager.address, "street", ""),
                  district: _get(this.merchantManager.address, "district", ""),
                  city: _get(this.merchantManager.address, "city", ""),
                  number: _get(this.merchantManager.address, "number", ""),
                  complement: _get(
                    this.merchantManager.address,
                    "complement",
                    ""
                  ),
                  UF: _get(this.merchantManager.address, "uf", ""),
                  zipCode: _get(this.merchantManager.address, "zipCode", ""),
                },
              };
              this.loading = false;
            } catch (e) {
              throw {
                response: {
                  data: {
                    failureReason: "Deu ruim na chamada...",
                  },
                },
              };
            }
          })
          .catch((e) => {
            this.loading = false;
          });
      }
    },

    handleZipCode(value) {
      if (value.length == 9) {
        value = MaskUtils.unFormat(value);
        this.isLoadingZipcodeBureau = true;
        MerchantBurealResource.getZipcodeInfo({ id: value })
          .then((result) => {
            try {
              this.form.address.street = result.data.payload.logradouro;
              this.form.address.district = result.data.payload.bairro;
              this.form.address.city = result.data.payload.localidade;
              this.form.address.domplement = result.data.payload.complemento;
              this.form.address.UF = result.data.payload.uf;
              this.isLoadingZipcodeBureau = false;
            } catch (e) {
              throw {
                response: {
                  data: {
                    failureReason: "Deu ruim na chamada...",
                  },
                },
              };
            }
          })
          .catch((e) => {
            this.isLoadingZipcodeBureau = false;
          });
      }
    },

    generatePassword(){

      this.$nprogress.start();
      this.loading = true;
      const v = this;

      if(!this.form.newPassword || this.form.newPassword.length < 8){
        v.$notification["error"]({
          message: "Erro",
          description: "A Senha precisa conter no mínimo 8 caracteres",
        });
        this.loading = false;
        this.$nprogress.done();
        return;
      }

      UsuarioResource.generatePassword({
        userName: this.form.document,
        email: this.form.email,
        newPassword: this.form.newPassword,
      })
        .then((response) => {
          this.loading = false;
          this.$nprogress.done();
          if (response.data.isSuccess) {
            try {
              v.$notification["success"]({
                message: "Sucesso",
                description: "Senha alterada com sucesso",
              });
              this.form.newPassword = ''
            } catch (e) {
              throw v.erroPadrao;
            }
          } else {
            throw v.erroPadrao;
          }
        })
        .catch((error) => {

          this.loading = false;
          var warn = {
            message: "Não foi possível concluir a alteração",
            description: error.message,
          };

          if (error.response.data.failureReason) {
            warn.description = error.response.data.failureReason;
          }

          this.$nprogress.done();
          this.$notification["error"](warn);
        });

    },

    forgotPasswordSend() {
      this.$nprogress.start();
      this.loading = true;
      const v = this;
      UsuarioResource.forgotPassword({
        userName: this.form.document,
      })
        .then((response) => {
          this.loading = false;
          this.$nprogress.done();
          if (response.data.isSuccess) {
            try {
              v.$notification["success"]({
                message: "Logged In",
                description: "Solicitação concluída, confira seu email",
              });
            } catch (e) {
              throw v.erroPadrao;
            }
          } else {
            throw v.erroPadrao;
          }
        })
        .catch((error) => {
          this.loading = false;
          var warn = {
            message: "Não foi possível concluir o reenvio",
            description: error.message,
          };

          if (error.response.data.failureReason) {
            warn.description = error.response.data.failureReason;
          }

          this.$nprogress.done();
          this.$notification["error"](warn);
        });
    },

    async onSubmit(e) {
      e.preventDefault();
      this.loading = true;
      const data = {
        ...this.form,
        //id: parseInt(this.$route.params.id),
        idSaleChannel: parseInt(this.$store.getters.user.salechannel),
        idMerchantManager: this.merchantManager.id || 0,
        idMerchant: this.idMerchant || 0,
      };

      data.idMerchant = parseInt(data.idMerchant);
      data.phoneNumber = MaskUtils.unFormat(data.phoneNumber);
      data.document = MaskUtils.unFormat(data.document);

      data.birthDate = moment(data.birthDate, "DD/MM/YYYY").isValid()
        ? moment(data.birthDate, "DD-MM-YYYY").format("YYYY-MM-DD")
        : null;

      if (!this.hasMerchantManager) {
        // add user
        const userObj = {
          fullName: data.fullName,
          documentNumber: data.document,
          userName: data.email,
          password: "",
          email: data.email,
          birthDate: data.birthDate,
          role: "Merchant-Manager",
          phoneNumber: data.phoneNumber,
          IdSaleChannel: data.idSaleChannel,
        };

        UsuarioResource.register(userObj)
          .then((result) => {
            data.idMerchantManager = result.data.payload;

            MerchantManagerResource.registerMerchantManager(data)
              .then((result) => {
                try {
                  this.idMerchant = result.data.payload;
                  this.loading = false;
                  this.$notification["success"]({
                    message: "Registro inserido",
                    description: "",
                  });
                } catch (e) {
                  throw {
                    response: {
                      data: {
                        failureReason: "Deu ruim na chamada...",
                      },
                    },
                  };
                }
              })
              .catch((e) => {
                this.loading = false;
              });

            this.loading = false;
          })
          .catch((e) => {
            this.loading = false;
          });
      } else {
        UsuarioResource.updateUser(data, {
          id: this.merchantManager.id,
        })
          .then((result) => {
            try {
              this.idMerchant = result.data.payload;
              this.loading = false;
              this.$notification["success"]({
                message: "Registro atualizado",
                description: "",
              });
            } catch (e) {
              throw {
                response: {
                  data: {
                    failureReason: "Deu ruim na chamada...",
                  },
                },
              };
            }
          })
          .catch((e) => {
            this.loading = false;
          });
      }
    },
    copyData() {
      const _m = _cloneDeep(this.merchant);
      this.form.fullName = _m.name;
      this.form.document = _m.document;
      this.form.birthDate = _m.birthDate;
      this.form.email = _m.email;
      this.form.phoneNumber = _m.phoneNumber;
      this.form.address = _m.address;
    },
  },
  mounted() {},
};
</script>

<style lang="css">
.width-150 {
  width: 150px;
}
.form .is-invalid,
.form .is-valid {
  padding-right: 0;
}
</style>
